// extracted by mini-css-extract-plugin
export default {"outsideBar":"PercentageSlider_outsideBar__iX58h"};